import { ContractConceptRelationshipState } from '../../states/ContractConceptRelationship.State';
import * as actions from '../../actions/ContractConceptRelationship.Actions';

import { ContractConceptRelationshipUnloadState } from '../../states/ContractConceptRelationship.State';

export default function ContractConceptRelationshipGetAllReducer(
  state: ContractConceptRelationshipState | undefined,
  action: any
): ContractConceptRelationshipState {
  const currentState = state ?? ContractConceptRelationshipUnloadState;
  switch (action.type) {
    case actions.CONTRACT_CONCEPT_REL_GET_ALL_REQUEST:
      return {
        ...currentState,
        isLoadingAll: true,
        successLoadingAll: undefined,
        failOnLoadingAll: false,
        error: undefined,
      };
    case actions.CONTRACT_CONCEPT_REL_GET_ALL_SUCCESS:
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: true,
        failOnLoadingAll: false,
        list: action.items,
      };
    case actions.CONTRACT_CONCEPT_REL_GET_ALL_FAILURE:
      return {
        ...currentState,
        isLoadingAll: false,
        successLoadingAll: false,
        failOnLoadingAll: true,
        error: action.error,
      };
    default:
      return currentState;
  }
}
